import { render, staticRenderFns } from "./SerialModal.vue?vue&type=template&id=911e540a"
import script from "./SerialModal.vue?vue&type=script&lang=js"
export * from "./SerialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports